exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-dialog {\n  min-width: 250px; }\n\n.modal-title {\n  padding-top: 25px;\n  text-align: center; }\n\n.modal-body {\n  text-align: center; }\n\n.modal-footer {\n  text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/alerta/alerta.component.scss
// module id = ../../../../../src/app/angular-base-ui/alerta/alerta.component.scss
// module chunks = 1